<template>
  <TheGlobalLoading />
</template>

<script>
import rebrand from '../../../config/rebrand';
import TheGlobalLoading from '../../Layout/components/TheGlobalLoading';
import JWTTokenStrategy from '../../../auth/tokenStrategies/jwtTokenStrategy';

export default {
  name: 'AuthSurrogate',
  components: { TheGlobalLoading },
  data() {
    return {
      appUrl: process.env.APP_DOMAIN_URL,
      pageManagerUrl: rebrand.urls.PAGE_MANAGER_URL,
    };
  },
  methods: {
    redirectToSurrogateSession() {
      const redirectTo = this.$route.query.redirect_to;

      window.location.href = this.isValidRedirect(redirectTo)
        ? `${this.appUrl}/${redirectTo}`
        : this.pageManagerUrl;
    },

    isValidRedirect(redirect) {
      if (redirect === null || redirect === undefined || redirect === '') {
        return false;
      }

      return true;
    },

    removeJWTToken() {
      const jwtToken = new JWTTokenStrategy();

      jwtToken.removeToken();
    },
  },
  created() {
    this.removeJWTToken();

    sessionStorage.setItem('surrogate-enabled', 'true');

    this.redirectToSurrogateSession();
  },
};
</script>



// WEBPACK FOOTER //
// src/screens/Auth/components/Surrogate.vue